import { Procedure } from "../../../../../services/scheduleService/model/schedule/Procedure";

export function ProcedureMapper(procedures:Procedure[]):Procedure[]{
    let newProcs = procedures.map(i => ({...i, startTime: new Date(new Date(i.startTime!).getTime() - (new Date(i.startTime!).getTimezoneOffset() * 60000)),
        endTime: new Date(new Date(i.endTime!).getTime() - (new Date(i.endTime!).getTimezoneOffset()*60000))}))
    return newProcs;
}